import DeckRoadwayEditor from "./DeckRoadwayEditor";
import {Select} from "antd";
import {useEffect, useState} from "react";

export default function DeckRoadwayWindow({data, selected}) {
    const [_selected, setSelected] = useState(selected)
    const [_data, setData] = useState({
        baseData: null,
        baseTitle: '',
        compareData: null,
        compareTitle: ''
    })

    useEffect(() => {
        const row = data?.data?.find(x => x.cross_section === _selected)
        if(row) {
            setData({
                baseData: row?.deck_dist_data?.base,
                baseTitle: row?.deck_dist_data?.base_title,
                compareData: row?.deck_dist_data?.cmp,
                compareTitle: row?.deck_dist_data?.compare_title,
            })
        }
    }, [_selected])




    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 6, marginBottom: 16}}>
                <label>
                    River Station:
                </label>
                <Select
                    style={{minWidth: 200}}
                    value={_selected}
                    onChange={(val) => {setSelected(val)}}
                    size={'small'}
                >
                    {data?.data?.map(x => {
                        return (
                            <Select.Option value={x.cross_section}>
                                {x.cross_section}
                            </Select.Option>
                        )
                    })}
                </Select>
            </div>
            <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                {
                    _data.baseData ? (
                        <DeckRoadwayEditor
                            windowName={'deck-base'}
                            data={_data.baseData}
                            title={_data.baseTitle}
                        />
                    ) : (<></>)
                }
                {
                    _data.compareData ? (
                        <DeckRoadwayEditor
                            windowName={'deck-cmp'}
                            targetWindow={'deck-base'}
                            data={_data.compareData}
                            title={_data.compareTitle}
                        />
                    ) : (<></>)
                }
            </div>
        </>
    )
}